import { ValidationFailure } from "../../../errors/validation-failure";
import Guard from "../../../guard";
import { IRequestById } from "../request-by-id";
import { ValidatorBase } from "./validator-base";

export class RequestByIdValidator extends ValidatorBase {
    validate(requestById: IRequestById): Array<ValidationFailure> {
        Guard.notNull(requestById);

        if (requestById.recipients == null) {
            const failure = new ValidationFailure(`Recipients cannot be null.`);
            this.addFailure(failure);
        }

        if (requestById.recipients.length === 0) {
            const failure = new ValidationFailure(`At least 1 recipient must be specified.`);
            this.addFailure(failure);
        }

        try {
            Guard.validIds(requestById.recipients);
        } catch (error) {
            const failure = new ValidationFailure(`Ids must be strictly positive.`);
            this.addFailure(failure);
        }

        return this.getFailures();
    }
}
